import { FC } from "react";
import { motion } from "framer-motion";

import "./HomeButtons.css";

import { PrimaryLink } from "./PrimaryLink";
import { RouteKey } from "../configs/routes";
import { useStorage } from "../utils/useStorage";
import { IconButtonLink } from "./IconButton";
import { HistoryIcon, PlusIcon } from "./Icons";

export const HomeButtons: FC = () => {
  const { isReady } = useStorage();

  return (
    <motion.div
      className="home-buttons"
      initial={{
        y: isReady ? 0 : 200,
        scale: isReady ? 1 : 0
      }}
      animate={{
        y: 0,
        scale: 1
      }}
      transition={{
        duration: 0.7,
        ease: [0.19, 1, 0.22, 1]
      }}
    >
      <div className="home-buttons__item home-buttons__item--pre">
        <div className="home-buttons__mock" />
      </div>
      <div className="home-buttons__item">
        <PrimaryLink route={RouteKey.ADD_DRINK}>
          <PlusIcon />
        </PrimaryLink>
      </div>
      <div className="home-buttons__item home-buttons__item--post">
        <IconButtonLink route={RouteKey.HISTORY} className="home-buttons__link">
          <HistoryIcon />
        </IconButtonLink>
      </div>
    </motion.div>
  )
}